import React from "react";
import { Toggle } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Toggle public mode for funko conventions.
 */
export const TogglePublicFunko = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-public-funko-error",
  };

  const inputProps = {
    id: "toggle-public-funko",
    className: "form-control",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "switch form-control-label",
    htmlFor: inputProps.id,
    children: "SET TO PUBLIC - FUNKO",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.IS_PUBLIC_FUNKO,
  };

  return <Toggle {...parentProps} />;
};
